export default {
  Other: "Khác",
  More: "Xem thêm",
  Total: "Tổng",
  Quantity: "Số lượng",
  RepaireTimes: "Số lần sửa chữa",
  MaintenanceTimes: "Số lần bảo dưỡng",
  Amount: "Giá trị",
  Chart: {
    AssetCategory: "Thống kê theo nhóm tài sản",
    AssetType: "Thống kê theo loại tài sản",
    RepaireCostsFluctuation: "Chi phí sửa chữa tài sản",
    MatainCostsFluctuation: "Chi phí bảo dưỡng tài sản",
  },
  Short: {
    AssetCategory: "Nhóm",
    Assetype: "Loại",
  },
  Filter: {
    Title: "Tham số",
    ManagementUnit: "Đơn vị quản lý",
    AssetCategory: "Nhóm tài sản",
    AssetType: "Loại tài sản",
    ChartType: "Loại biểu đồ",
    DotnutChart: "Biểu đồ tròn",
    BarChart: "Biểu đồ cột",
    All: "Tất cả",
    Period: "Thời gian",
    Costs: "Loại chi phí",
    CostType: {
      Repaire: "Chi phí sửa chữa",
      Maintenance: "Chi phí bảo dưỡng",
    },
    PeriodType: {
      Month: "Tháng",
      MonthShort: "T",
      Quater: "Quý",
      Year: "Năm",
      MonthLastYear: "Năm trước (tháng)",
      QuaterLastYear: "Năm trước (quý)",
      LastYear: "Năm trước (năm)",
    },
    FromMonth: "Từ tháng",
    ToMonth: "Đến tháng",
    FromYear: "Từ năm",
    ToYear: "Đến năm",
    Year: "Năm",
    Arrange: "từ {0} đến {1}",
  },
  Milion: "Triệu",
  Bilion: "Tỷ",
  SummaryAssetByStatusChart: {
    AssetTotalAmount: "Tổng giá trị tài sản",
    Group1: "Đang sử dụng",
    Group2: "Chưa sử dụng",
    Group3: "Hỏng, sửa chữa, bảo dưỡng",
    Group4: "Mất, hủy, thanh lý",
    Group5: "Khác",
    Group5Value: "Báo hỏng, báo mất, đề nghị thanh lý, đang điều chuyển",
  },
  CompareManagementUnit: "So sánh đơn vị quản lý",
  Param: "Tham số",
  BrokenRepairMaintain: "Hỏng, sửa chữa, bảo dưỡng",
  ChartAssetFluctuation: "Biến động tài sản",
  Time: "Thời gian",
  Quarter: "Quý",
  StatisticBy: "Thống kê theo",
  StatisticAssetByManagementUnit: "Thống kê tài sản theo đơn vị quản lý",
  StatisticAssetByUsedOrganizationUnit: "Thống kê tài sản theo đơn vị sử dụng",
  ThisYearMonth: "Tháng",
  ThisYearQuarter: "Quý",
  ThisYearYear: "Năm",
  LastYearMonth: "Năm trước (tháng)",
  LastYearQuarter: "Năm trước (quý)",
  LastYearYear: "Năm trước (năm)",
  Group: "Nhóm",
  notAllowSmaller: "{0} không được nhỏ hơn {1}",

  // JetPay
  Title: {
    TransactionList: "Danh sách giao dịch thanh toán",
    ComplaintList: "Danh sách khiếu nại",
    RefundList: "Danh sách hoàn tiền",
    TransactionValue: "Giá trị giao dịch thanh toán",
    TransactionAmount: "Số lượng giao dịch thanh toán",
    SettingLabel: "Tài khoản của bạn đã được phê duyệt. Bắt đầu thiết lập để sử dụng",
  },

  ChangeToDonutChart: "Chuyển sang biểu đồ tròn",
  ChangeToBarChart: "Chuyển sang biểu đồ cột",
  RefreshChart: "Làm mới dữ liệu",
  ChartSuccessTooltip: "Thống kê các giao dịch thanh toán thành công trong kỳ",
  ChartRefundTooltip: "Thống kê các giao dịch hoàn tiền phát sinh trong kỳ",
  ChartAmountTooltip:
    "Là số tiền giao dịch thành công trừ đi số tiền hoàn và phí phải trả cho JETPAY trong kỳ",
  ChartPieTooltip: "Tỷ lệ khách hàng thanh toán theo từng hình thức",

  //Xác nhận email
  EmailConfirm: {
    EmailConfirm: "Xác nhận email",
    Welcome: "Chào mừng bạn đến với JETPAY!",
    Detail: "Đầu tiên, hãy kiểm tra email xxxx để xác mình tài khoản của bạn.",
    NoEmail: "Chưa nhận được email?",
    Resend: "Gửi lại email xác minh",
    ChangeEmail: "Thay đổi email",
    InforIdentify: 'Nhấn vào "Khai báo hồ sơ" để khai báo thông tin định danh tài khoản.',
    Identify: "Khai báo thông tin",
  },
  Message: {
    SaleReceived:
      'JETPAY đang phê duyệt hồ sơ của bạn. Nhấn "Xem hồ sơ" hoặc liên hệ tổng đài <b>1900 2169</b> nếu cần hỗ trợ.',
    InforIdentify:
      "JETPAY đang phê duyệt hồ sơ của bạn. Vui lòng quay lại sau khi hồ sơ đã phê duyệt hoặc liên hệ tổng đài <b>1900 2169</b> nếu cần hỗ trợ.",
    DeclineReason: "Tài khoản của quý khách không được phê duyệt do xxxx. Vui lòng cập nhật lại",
    UpdateRisk: "Hồ sơ của bạn chưa hợp lệ. Vui lòng",
    UpdateRisk1: "nhấn vào đây",
    UpdateRisk2: "để xem lý do và cập nhật thông tin hồ sơ của bạn.",
    Reason: "Lý do: ",
    ProfileNeedUpdating: "Hồ sơ cần cập nhật",
    EmailNotActivated: "Tính năng đang tạm khóa. Vui lòng kích hoạt email của bạn để sử dụng",
    TemporarilyLockFeature: "Tính năng đang tạm khóa. Vui lòng khai báo hồ sơ để sử dụng.",
    ProfileNotApprovedYet: "Tính năng sẽ được mở sau khi hồ sơ của bạn được JETPAY phê duyệt.",
    Decline:
      "Hồ sơ đăng ký dịch vụ cổng thanh toán của bạn chưa được phê duyệt. Vui lòng liên hệ <b>1900 2169</b> để biết thêm chi tiết",
  },
  ButtonTitle: {
    Identify: "Khai báo hồ sơ",
    InforShow: "Xem hồ sơ",
    DeclineReason: "Cập nhật",
    UpdateRisk: "Bổ sung",
    View: "Xem hồ sơ",
  },
  LayoutTitle: {
    Payment: "Thanh toán",
    Refund: "Hoàn tiền",
    Received: "Thực nhận",
    Fee: "Phí",
    Unit: "Tr.đ",
    Amount: "GD",
    Delivered: "Đã chuyển",
    Existence: "Còn lại",
    Paying: "Giao dịch",
    NameMoney: "Số tiền",
    NameQuality: "Số lượng",
  },
  UnitVN: {
    Unit: "VND",
    Million: "Tr.",
  },
  LicenseAgreement: "Xác nhận thỏa thuận sử dụng dịch vụ.",
  LicenseAgreementError: "Đã có lỗi xảy ra xin vui lòng thử lại.",
  LicenseAgreementSuccess:
    "Xác nhận thành công. Cảm ơn quý khách đã tin tưởng sử dụng dịch vụ của JETPAY.",
};
